// extracted by mini-css-extract-plugin
export default {"banner":"Q7VNLTsOrV3sc_Das4uR","warningIcon":"ObNnRPSTFEmKveuzQLeP","warning":"bEh4XSRspTIUDR6B1k0Q"};